var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1404c3bd8a6fba7eb3694fc40d2291bbaee36c78"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breitbart-nextjs-web@sentry"]={id:"1404c3bd8a6fba7eb3694fc40d2291bbaee36c78"};
      